import React from 'react'
import {
  ShopNowBox,
  ShopNowText,
  ShopNowButton,
  ShopNowContainer
} from './style/ShopNow.css'

export default function ShopNow({ navigateToVehicle }) {
  return (
    <ShopNowContainer>
      <ShopNowBox>
        <ShopNowText>
          FIND PARTS FOR YOUR VEHICLE
        </ShopNowText>
        <ShopNowButton
          label="Shop Now"
          onClick={navigateToVehicle}
        />
      </ShopNowBox>
    </ShopNowContainer>
  )
}